<template>
  <div>
    <Header2 />
    <div class="order-confirm">
      <BreadcrumbGroup />
      <OrderConfirmForm :productDetail="productDetail" />
    </div>
  </div>
</template>

<script>
import Header2 from '@/components/Header/index'
import BreadcrumbGroup from '@/components/BreadcrumbGroup'
import OrderConfirmForm from './components/orderConfirmForm.vue'
import { IsAllowUserSubmitApply } from '@/features/judgeUser'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    Header2,
    BreadcrumbGroup,
    OrderConfirmForm
  },
  mounted () {
    this.$store.dispatch('area/getFullArea')
  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      vm.userType === '个人' && vm.$router.replace({ name: 'product-detail' })
      const result = await IsAllowUserSubmitApply(vm)
      !result && vm.$router.replace('/product-detail')
    })
  },
  methods: {
    ...mapActions('user', [
      'getUserDishonestyInfo'
    ])
  },
  computed: {
    ...mapState('user', {
      userType: state => state.userType
    }),
    ...mapState('product', {
      productDetail: state => state.productDetail
    })
  }
}
</script>
<style lang="scss" scoped>
.order-confirm {
  @include common-layout;
  padding-bottom: 100px;
}
</style>
